import React, {useEffect, useState} from "react";
import {Box, Grid, Typography} from "@mui/material";
import {DeviceCard} from "../components/DeviceCard";
import {useSelector} from "react-redux";
import {RootState} from "../app/store";
import {UserDevices} from "../app/features/userSlice";


interface MyDevices {

    id: number
    imei: string
    category_id: number
    createdAt: string
    updatedAt: string
    UserDevices: UserDevices
}

export const MyDevices = () =>{

    const allDevices = useSelector(((state:RootState) => state.user.distinctDevices))
    const allCategories = useSelector((state:RootState)=>state.user.categories)

    const  [devices,setDevices] = useState<MyDevices[]>([])


    useEffect(()=>{
        fetchCards()
    },[])

    const fetchCards = () =>{
        setDevices(allDevices.map((d :any)=>{
            return {
                ...d,
            }
        }))
    }

    return(
        <Box sx={{width:"100%"}}>
            <Grid container>
                <Grid item marginTop={3}>
                    <Typography
                        fontSize={24}
                        fontWeight={500}
                        color="#081735"
                    >
                        Devices
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={5} marginTop={"1px"}>
                {
                    // !skelton ?
                        devices.map((d : any,index)=>(
                            <DeviceCard
                                id={d.id}
                                name={d.alias}
                                Imei={d.deviceId}
                                Category={d.category}
                                key={index}
                                setDevices = {setDevices}
                            />
                        ))
                        // :
                        // skeltonCards.map((e)=>(
                        //     <Grid item md={10} sm={10} xs={15} xl={3} key={e}>
                        //         <Stack spacing={2} alignItems="center" className="card-skeleton">
                        //             <div className="dashboard--portrait-skeleton">
                        //                 <Skeleton variant="circular" animation="wave" width={105} height={105} />
                        //             </div>
                        //             <Skeleton variant="text" width={150} animation="wave" />
                        //             <Stack direction="row" spacing={2}>
                        //                 {
                        //                     readings.map(e=>(
                        //                         <StackRowSekelton  key={e} />
                        //                     ))
                        //                 }
                        //             </Stack>
                        //         </Stack>
                        //     </Grid>
                        // ))
                }

            </Grid>
        </Box>
    )
}